<template>
  <v-card class="manageCodeList col-12 mt-7 mb-4 pb-0">
    <div class="row justify-end mt-0 mb-0">
      <div class="row justify-start mt-0 mb-0" style="padding-left: 25px;">
        <v-btn
          small
          color="grey darken-4"
          class="white--text"
          @click="removeCode()"
          >정품인증코드 파기</v-btn
        >
      </div>

      <v-btn
        small
        color="green"
        class="white--text ml-3 mr-3"
        @click.prevent="excelDownload"
        >엑셀 다운로드</v-btn
      >
    </div>

    <v-data-table
      v-model="selectedProduct"
      :headers="headers"
      :items="productInfos"
      :server-items-length="productInfosCount"
      :options.sync="options"
      :loading="tableLoading"
      calculate-widths
      show-select
      :items-per-page="$parent.$refs.searchComponent.searchPayload.limit"
      :footer-props="{
        'items-per-page-options': [10, 20, 30, 40, 50],
        'items-per-page-text': '목록 노출 수 선택:'
      }"
      item-key="serial_number"
      scrollable
    >
      <template v-slot:[`item.created`]="{ item }">
        <p
          class="mb-0 mt-3 text-center caption"
          v-html="$options.filters.defaultDate(item.created_at)"
        ></p>
      </template>

      <template v-slot:[`item.authCode`]="{ item }">
        <p class="mb-0 mt-3 caption">
          {{ item.serial_number }}
        </p>
      </template>

      <template v-slot:[`item.image`]="{ item }" class="pl-0 pr-0 ml-0 mr-0">
        <v-row no-gutters>
          <v-col>
            <v-img
              v-if="item.list_image"
              :src="item.list_image"
              width="60px"
              height="60px"
            ></v-img>
            <v-img
              v-else
              :src="adminDefaultImg"
              width="60px"
              height="60px"
            ></v-img>
          </v-col>
        </v-row>
      </template>

      <template
        v-slot:[`item.productInfo`]="{ item }"
        class="pl-0 pr-0 ml-0 mr-0"
      >
        <v-row no-gutters>
          <v-col
            class="pl-0 pr-0 ml-0 mr-0 d-flex"
            style="width:170px;overflow: hidden; text-overflow: ellipsis; ; white-space: nowrap;"
          >
            <div class="d-flex align-center mr-3">
              <v-img
                v-if="item.list_image"
                :src="item.list_image"
                width="70px"
                height="70px"
              ></v-img>
              <v-img
                v-else
                :src="adminDefaultImg"
                width="70px"
                height="70px"
              ></v-img>
            </div>
            <div>
              <p class="mb-0 mt-3 mr-0 text-left text-truncate caption">
                {{ item.product_name }}
              </p>
              <p class="mb-0 mr-0 text-left text-truncate caption">
                옵션 : {{ item.variant_name }}
              </p>
              <p class="mb-0 mr-0 text-left text-truncate caption">
                상품코드 : {{ item.product_code }}
              </p>
              <p class="mb-3 mr-0 text-left text-truncate caption">
                품목코드 : {{ item.variant_code }}
              </p>
            </div>
          </v-col>
        </v-row>
      </template>

      <template v-slot:[`item.warrantyPeriodDays`]="{ item }" class="pl-0 pr-0">
        <a
          @click="daysClick(item)"
          class="caption"
          v-html="
            $options.filters.warrantyPeriod({
              cert_status: item.cert_status,
              cert_duration_type: item.cert_duration_type,
              cert_duration: item.cert_duration,
              cert_validated_at: item.cert_validated_at,
              cert_expired_at: item.cert_expired_at
            })
          "
        ></a>
      </template>

      <template v-slot:[`item.authState`]="{ item }" class="pl-0 pr-0">
        <p class="mb-0 caption">
          {{ item.cert_status | certStatus }}
        </p>
      </template>

      <template v-slot:[`item.authDate`]="{ item }" class="pl-0 pr-0">
        <p
          class="mb-0 text-center caption"
          v-html="$options.filters.defaultDate(item.activated_at)"
        ></p>
      </template>

      <template v-slot:[`item.authUserId`]="{ item }" class="pl-0 pr-0">
        <p
          class="mb-0 text-start caption"
          @click="showMemberInfoPage(item.member_id)"
        >
          <a>
            ID : {{ item.member_id | defaultString }} <br />
            이름 : {{ item.member_name | defaultString }} <br />
            전화번호 : {{ item.member_hp | defaultString }} <br />
            이메일 : {{ item.member_email | defaultString }} <br />
          </a>
        </p>
      </template>

      <template v-slot:[`item.send`]="{ item }" class="pl-0 pr-0">
        <div v-if="item.member_hp || item.member_email">
          <v-btn small color="blue" class="white--text" @click="sendBtn(item)"
            >재발송하기</v-btn
          >
        </div>
        <div v-else>
          <!--
          <v-btn
            small
            color="grey"
            class="white--text"
            @click="reSendDisableAlert()"
            >재발송하기</v-btn
          >
          -->
          <p class="mb-0">-</p>
        </div>
      </template>

      <template slot="no-data">
        <div class="noDataProductInfos">내역이 없습니다.</div>
      </template>
    </v-data-table>

    <!--
      Modal
    -->
    <v-row justify="center">
      <v-dialog persistent max-width="310" v-model="removeConfirm">
        <v-card>
          <v-card-title class="headline"></v-card-title>
          <v-card-text>
            <p class="mb-0">선택하신 정품인증코드를 파기하시면</p>
            <p class="mb-0">관련된 이력과 함께 모두 사라지게 됩니다.</p>
            <p class="mb-0">정말로 파기하시겠습니까?</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="black darken-1"
              text
              @click.prevent="removeConfirm = false"
              >취소</v-btn
            >
            <v-btn color="blue darken-1" @click.prevent="sendRemoveCode" text
              >파기</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!--
      재발송하기 Modal
    -->
    <v-row justify="center">
      <v-dialog v-model="reSendModal" max-width="340px">
        <v-card>
          <v-card-title>SMS/메일 재발송</v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pb-0">
            <p class="mt-7 body-2 black--text">
              - 고객 CS 유입시 재발송 처리가 가능합니다.
            </p>

            <v-col
              class="d-inline-block col-auto mr-auto mr-0 ml-0 pl-0 pt-0 pb-0 pr-0"
            >
              <div class="mt-2">
                <p
                  class="mt-3 mr-3 mb-0 body-1 black--text"
                  style="float:left;"
                >
                  핸드폰
                </p>
                <v-text-field
                  v-model="reSendParams.member_hp"
                  outlined
                  dense
                  height="50px"
                  placeholder="핸드폰번호 입력"
                  class="d-inline-block"
                  :style="{ width: '230px' }"
                  @keydown="M.phoneNumberCheck($event)"
                  @keyup="M.phoneNumberCheck($event)"
                ></v-text-field>
              </div>

              <div>
                <p
                  class="mt-3 mr-3 mb-0 body-1 black--text"
                  style="float:left;"
                >
                  이메일
                </p>
                <v-text-field
                  v-model="reSendParams.member_email"
                  outlined
                  dense
                  height="50px"
                  placeholder="이메일 입력"
                  class="d-inline-block"
                  :style="{ width: '230px' }"
                ></v-text-field>
              </div>
            </v-col>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="reSendModal = false"
              >닫기</v-btn
            >
            <v-btn color="blue darken-1" text @click="reSendSave()"
              >재발송</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <AuthCodeClickModal ref="AuthCodeClickModal"></AuthCodeClickModal>
    <QrCodePrintModal ref="QrCodePrintModal"></QrCodePrintModal>
    <AuthWarrantyPeriodChangeModal
      ref="AuthWarrantyPeriodChangeModal"
    ></AuthWarrantyPeriodChangeModal>
    <UnAuthWarrantyPeriodChangeModal
      ref="UnAuthWarrantyPeriodChangeModal"
    ></UnAuthWarrantyPeriodChangeModal>
    <AuthStateChangeModal ref="AuthStateChangeModal"></AuthStateChangeModal>
  </v-card>
</template>
<style scoped>
.noDataProductInfos {
  padding: 50px 0;
}
.manageCodeList a:hover {
  text-decoration: underline;
}
.disabledBtn {
  height: 28px;
  min-width: 50px;
  padding: 0 12.4444444444px;
  font-size: 0.75rem;
  background-color: #f5f5f5;
  color: #bababa;
}
</style>
<script>
import M from "@/libs/mapping.js";
import { AUTH_SERVICE } from "@/datas/authservice";
import CommonMixin from "@/mixins/CommonMixin.js";
import Filters from "@/libs/authservice/filters.js";
import AuthCodeClickModal from "@/components/authservice/authcode/modal/AuthCodeClickModal.vue";
import QrCodePrintModal from "@/components/authservice/authcode/modal/QrCodePrintModal.vue";
import AuthWarrantyPeriodChangeModal from "@/components/authservice/authcode/modal/AuthWarrantyPeriodChangeModal.vue";
import UnAuthWarrantyPeriodChangeModal from "@/components/authservice/authcode/modal/UnAuthWarrantyPeriodChangeModal.vue";
import AuthStateChangeModal from "@/components/authservice/authcode/modal/AuthStateChangeModal.vue";
import Excel from "@/libs/excel.js";

export default {
  data() {
    return {
      M,
      AUTH_SERVICE,
      headers: [
        {
          text: "생성일시",
          align: "center",
          sortable: false,
          value: "created",
          width: 100
        },
        {
          text: "시리얼인증코드",
          align: "center",
          value: "authCode",
          sortable: false,
          width: 230
        },
        {
          text: "품목 정보",
          align: "center",
          value: "productInfo",
          sortable: false
        },
        {
          text: "인증상태",
          align: "center",
          value: "authState",
          sortable: false,
          width: 90
        },
        {
          text: "인증일시",
          align: "center",
          value: "authDate",
          sortable: false,
          width: 100
        },
        {
          text: "인증회원ID",
          align: "start",
          value: "authUserId",
          sortable: false,
          width: 220
        },
        {
          text: "SMS/메일",
          value: "send",
          align: "center",
          sortable: false,
          width: 100
        }
      ],
      selectedProduct: [],
      removeConfirm: false,
      productInfos: [],
      productInfosCount: 0,
      options: {},
      tableLoading: false,
      excelData: {
        Excel: null,
        totalLimit: 200000,
        limit: 10000,
        totalCount: 0,
        offset: 0,
        sheetData: [],
        sheetHeader: {
          created_at: "생성일시",
          serial_number: "정품인증코드",
          product_name: "상품명",
          variant_name: "품목명",
          product_code: "상품코드",
          variant_code: "품목코드",
          cert_status: "인증상태",
          activated_at: "인증일시",
          member_id: "인증회원ID",
          member_name: "인증회원 이름",
          member_hp: "인증회원 전화번호",
          member_email: "인증회원 이메일"
        }
      },
      printSettingInfo: "N",
      adminDefaultImg: require("../../../assets/authservice/images/admin_default.png"),
      reSendModal: false,
      reSendParams: {
        serial_number: "",
        member_id: "",
        member_hp: "",
        member_email: "",
        product_name: "",
        variant_name: ""
      }
    };
  },
  components: {
    AuthCodeClickModal,
    QrCodePrintModal,
    AuthWarrantyPeriodChangeModal,
    UnAuthWarrantyPeriodChangeModal,
    AuthStateChangeModal
  },
  mixins: [CommonMixin],
  filters: Filters,
  created: async function() {
    //같은 자식 컴포넌트로 부터 setList 을 emit 한 함수를 on 으로 받아 setProductList 메소드 호출
    this.eventHub.$on("setList", this.setProductList);

    try {
      let data = await M.api(M.entry("/get/print"), {});
      if (data) {
        if (
          data.print_paper == "60*48mm a4 라벨지 (일반프린터)" ||
          data.print_paper == "선택해주세요."
        ) {
          data.print_paper = "";
        }
        if (
          data.print_template == "타입1" ||
          data.print_template == "선택해주세요."
        ) {
          data.print_template = "";
        }

        if (data.print_paper && data.print_template) {
          this.printSettingInfo = "Y";
        }
      }
    } catch (e) {
      this.printSettingInfo = "N";
    }
  },
  watch: {
    options: {
      handler() {
        this.$parent.$refs.searchComponent.execSearch(false);
      },
      deep: true
    }
  },
  methods: {
    setProductList: function(data) {
      this.selectedProduct = [];
      this.productInfosCount = data.count;
      this.productInfos = data.serials;
      this.tableLoading = false;
    },
    authCodeClick: function(data) {
      this.$refs.AuthCodeClickModal.authCodeClick(data);
    },
    daysClick: function(data) {
      this.$refs.UnAuthWarrantyPeriodChangeModal.warrantyPeriodClick(data);
    },
    authStateClick: function(data) {
      this.$refs.AuthStateChangeModal.authStateClick(data);
    },
    barCodePrintClick: function() {
      if (this.$store.state.mode !== AUTH_SERVICE.APP_MODE.PLUS) {
        this.alertShow(
          "해당 메뉴는 '플러스 버전' 에서 사용이 가능합니다.</br>[결제관리] 메뉴에서 버전을 변경/결제하여 사용해주세요."
        );
        return false;
      }

      if (!this.productInfos) {
        this.alertShow("정품QR코드 인쇄할 데이터가 없습니다.");
        return false;
      }

      if (this.printSettingInfo == "N") {
        this.alertShow(
          "인쇄 설정이 되어 있지 않습니다. [정품 QR 코드 인쇄 설정] 메뉴에서 설정하시면 사용이 가능합니다."
        );
        return false;
      }

      this.$refs.QrCodePrintModal.barCodePrintClick(
        this.$parent.$refs.searchComponent.$data.searchPayload
      );
    },
    /**
     * 엑셀 다운로드 체크
     */
    excelDownload: async function() {
      this.excelData.totalCount = 0;
      this.excelData.offset = 0;
      let excelPayload = this.$parent.$refs.searchComponent.$data.searchPayload;
      excelPayload["limit"] = this.excelData.limit;
      excelPayload["offset"] = 0;

      let data = await M.api(M.entry("/cert/serials/search"), excelPayload);
      if (data.length === 0) {
        this.alertShow("엑셀다운로드할 데이터가 없습니다.");
        return false;
      }
      this.excelData.totalCount = data.count;
      if (this.excelData.totalCount > this.excelData.totalLimit) {
        this.alertShow(
          "엑셀다운로드건수는 " +
            this.$options.filters.numberFormat(this.excelData.totalLimit) +
            "건</br>이내로 검색하여 다운로드 해주세요."
        );
        return false;
      }
      this.excelData.sheetData = data.serials;
      this.checkExcelDataChange();
      this.initExcelDownload();
    },
    /**
     * 엑셀 시작
     */
    initExcelDownload: function() {
      let progressText = "엑셀 다운로드중입니다.</br>잠시만 기다려 주세요.";
      this.circularProgressShow(progressText);
      // this.defaultProgressShow();
      this.excelData.Excel = new Excel(null, this.excelData.sheetHeader);
      this.addExcel();
    },
    /**
     * 엑셀 추가 데이터
     */
    getExcelDataAdd: async function() {
      this.excelData.offset = this.excelData.offset + this.excelData.limit;
      this.circularProgressSetValue(
        Math.round((this.excelData.offset / this.excelData.totalCount) * 100)
      );
      if (this.excelData.offset > this.excelData.totalCount) {
        await this.endExcel();
        return false;
      }
      let excelPayload = this.$parent.$refs.searchComponent.$data.searchPayload;
      excelPayload["limit"] = this.excelData.limit;
      excelPayload["offset"] = this.excelData.offset;
      let data = await M.api(M.entry("/cert/serials/search"), excelPayload);
      if (data.length === 0) {
        await this.endExcel();
        return false;
      }
      this.excelData.sheetData = data.serials;
      this.checkExcelDataChange();
      this.excelData.Excel.addSheet(this.excelData.sheetData);
      this.addExcel();
    },
    /**
     * 시트에 엑셀 추가
     */
    addExcel: async function() {
      if (this.excelData.offset === 0) {
        await this.excelData.Excel.initSheet();
        await this.excelData.Excel.addSheet(this.excelData.sheetData);
        await this.getExcelDataAdd();
      } else {
        await this.getExcelDataAdd();
      }
    },
    /**
     * 파일 다운
     */
    endExcel: async function() {
      setTimeout(() => {
        this.circularProgressHide();
      }, 1500);
      // this.defaultProgressHide();
      let toDay = new Date();
      let year = toDay.getFullYear();
      let month = 1 + toDay.getMonth();
      month = month >= 10 ? month : "0" + month;
      let day = toDay.getDate();
      day = day >= 10 ? day : "0" + day;
      await this.excelData.Excel.endSheet(
        `${year}${month}${day}_${this.$store.state.mallId}`
      );
    },
    /**
     * excel데이터 변경
     */
    checkExcelDataChange: function() {
      if (this.excelData.sheetData.length > 0) {
        this.excelData.sheetData.forEach(data => {
          for (let key in data) {
            if (key === "cert_status") {
              data[key] = this.$options.filters.certStatus(data[key]);
            }
            if (key === "cert_duration_type") {
              data[key] = this.$options.filters
                .warrantyPeriod(data)
                .replace("</br>", "");
            }
          }
        });
      }
    },
    removeCode: async function() {
      if (this.selectedProduct.length === 0) {
        this.alertShow("파기하실 정품 인증 코드를 선택해주세요.");
      } else {
        this.removeConfirm = true;
      }
    },
    sendRemoveCode: async function() {
      let payload = {
        serial_numbers: []
      };
      payload["serial_numbers"] = this.selectedProduct.map(
        item => item.serial_number
      );
      try {
        await M.api(M.entry("/serials/del"), payload);
        this.removeConfirm = false;
        this.eventHub.$emit("execSearch", false);
        alert("삭제되었습니다.");
      } catch (e) {
        this.removeConfirm = false;
        this.alertShow("현재 서버 통신이 불안정합니다. 잠시 후 사용해주세요.");
      }
    },
    checkVersionAlret: function() {
      let msg =
        "해당 메뉴는 '플러스 버전' 에서 사용이 가능합니다.</br>[결제관리] 메뉴에서 버전을 변경/결제하여 사용해주세요.";
      this.alertShow(msg);
    },
    sendBtn: function(v) {
      this.reSendParams.serial_number = v.serial_number;
      this.reSendParams.member_id = v.member_id;
      this.reSendParams.member_hp = v.member_hp;
      this.reSendParams.member_email = v.member_email;
      this.reSendParams.product_name = v.product_name;
      this.reSendParams.variant_name = v.variant_name;

      this.reSendModal = true;
    },
    showMemberInfoPage: function(memberId) {
      if (!memberId) {
        alert("인증된 회원 정보가 없습니다.");
        return false;
      }
      let url =
        "https://" +
        this.$store.state.mallId +
        ".cafe24.com/admin/php/shop1/c/member_admin_d_f.php?user_id=" +
        memberId;

      window.open(url, "_blank");
    },
    reSendDisableAlert: function() {
      return false;
      //alert("인증되지 않아 재발송 할 수 없습니다.");
    },
    //재발송 저장
    reSendSave: async function() {
      try {
        await M.api(
          M.entry("/serials/send/sms", this.reSendParams.serial_number),
          this.reSendParams
        );
      } catch (e) {
        alert("문자 재발송 실패 했습니다.");
      }

      try {
        await M.api(
          M.entry("/serials/send/email", this.reSendParams.serial_number),
          this.reSendParams
        );
      } catch (e) {
        alert("이메일 재발송 실패 했습니다.");
      }
      alert("발송 되었습니다.");
      this.reSendModal = false;
    }
  }
};
</script>
